// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Jdc-","buttons":"styles_buttons__3l82W"};